module.exports = __webpack_public_path__ + "static/media/card_sea_stars.502dae8e.jpg";